"use client";

import { c as _c } from "react/compiler-runtime";
import { type LumiSurveyBehavior, type LumiSurveyConfig, LumiSurveyDock, type LumiSurveyTransport } from "@navikt/lumi-survey";
import { submitLumiSurveyFeedback } from "@/server/actions/submitLumiSurveyFeedback.ts";
const transport: LumiSurveyTransport = {
  async submit(submission) {
    await submitLumiSurveyFeedback(submission.transportPayload);
  }
};
interface Props {
  feedbackId: string;
  behavior?: LumiSurveyBehavior;
  survey: LumiSurveyConfig;
}
export const Lumi = t0 => {
  const $ = _c(4);
  const {
    feedbackId,
    behavior,
    survey
  } = t0;
  let t1;
  if ($[0] !== behavior || $[1] !== feedbackId || $[2] !== survey) {
    t1 = <LumiSurveyDock surveyId={feedbackId} survey={survey} transport={transport} behavior={behavior} />;
    $[0] = behavior;
    $[1] = feedbackId;
    $[2] = survey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};